import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "border-1 fs-small lh-md" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "text-center bg-c02 text-white px-4 py-1"
}, " 種別 ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "text-center bg-c02 text-white px-3 py-1"
}, " 担当者 ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "text-center bg-c02 text-white px-4 px-lg-3 py-1"
}, " 時間 ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "text-center bg-c02 text-white px-5 py-1"
}, " 車種 ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "text-center bg-c02 text-white px-4 px-lg-3 py-1"
}, " 協力店 ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "text-center bg-c02 text-white px-5 py-1"
}, " 配送先 ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "text-center bg-c02 text-white px-4 px-lg-3 py-1"
}, " 備考 ", -1)
const _hoisted_9 = {
  key: 0,
  scope: "col",
  class: "text-center bg-c02 text-white px-5 px-lg-4 py-1"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "text-center bg-c02 text-white w-5em py-1"
}, " 処理 ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("thead", _hoisted_1, [
    _createElementVNode("tr", null, [
      _hoisted_2,
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _hoisted_6,
      _hoisted_7,
      _hoisted_8,
      (!_ctx.isMobile)
        ? (_openBlock(), _createElementBlock("th", _hoisted_9, " 更新 "))
        : _createCommentVNode("", true),
      _hoisted_10
    ])
  ]))
}